<template>
  <!-- 应用主容器 -->
  <div class="app">
    <!-- 页面头部组件 -->
    <Header></Header>
    <!-- 路由视图，根据当前路由动态加载不同的组件 -->
    <router-view />
    <!-- 页面底部组件 -->
    <!-- <Footer></Footer> -->
  </div>
</template>

<script>
// 导入头部组件
import Header from "@/components/Header";
// 导入底部组件
import Footer from "@/components/Footer";
export default {
  // 组件名称
  name: 'Home',
  // 组件数据
  data() {
    return {
      // 内容区域最小高度
      minHeight: 800,
    };
  },
  // 注册使用的子组件
  components: {
    Header,
    Footer
  },
};
</script>

<style>
/* 应用内容区域样式 */
.app-content {
  /* 设置最小高度，确保页面内容区域有足够的高度 */
  min-height: 800px;
}
</style>